import 'antd/dist/antd.min.css'
import AppRouter from 'components/common/AppRouter'

const App: React.FC = () => <AppRouter />

export default App
